<ng-container *ngIf="memo !== null">
    <ng-container *ngIf="type === 'toolbar'">
        <hpo-button id="detailsToolbarMemoButton"
            (click)="openMemoDialog()">
            <mat-icon [ngClass]="{'memo__badge': memo.length}">edit_note</mat-icon>
            <div class="toolbar-actions__btn">{{ 'default.memo' | blah }}</div>
        </hpo-button>
    </ng-container>
    <ng-container *ngIf="type === 'mobile'">
        <hpo-button id="detailsToolbarActionsPrintPdf"
            type="button"
            (click)="openMemoDialog()">
            <mat-icon [ngClass]="{'memo__badge': memo.length}">edit_note</mat-icon>
            {{ 'default.memo' | blah }}...
        </hpo-button>
    </ng-container>
</ng-container>